// extracted by mini-css-extract-plugin
module.exports = {"ErrorBox":"ErrorBox_ErrorBox__C-L8P","Active":"ErrorBox_Active__1kFDS","fadein":"ErrorBox_fadein__39iPT"};